/* Universal birthstone swatch map — Ava Lockhart.
   Any option value containing a month name resolves to its gem swatch
   (hosted on the store's own CDN). Used by the B1G2 offer widget + quick-pick;
   reusable by any other component: window.ALSwatches.forValue("June") -> url.

   2026-07-27: shape-aware maps added from the TRUE supplier stone photos
   (project folder "birthstone swatches/"). Pass the OPTION NAME as the 2nd
   arg — forValue("June", "Oval Stone") -> pear-cut June photo,
   forValue("June", "Rectangle Stone") -> radiant-cut June photo. Option
   names matching oval/pear use `pear`; rect/radiant/square use `rect`;
   anything else falls back to the generic round map below. */
window.ALSwatches = {
  map: {
    January:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/January_-_Garnet_-_Round.png?v=1790613392",
    February:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/February_-_Amethyst_-_Round.png?v=1790613394",
    March:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/March_-_Aquamarine_-_Round.png?v=1790613395",
    April:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/April_-_Diamond_-_Round.png?v=1790613397",
    May: "https://cdn.shopify.com/s/files/1/1705/5713/files/May_-_Emerald_-_Round.png?v=1790613398",
    June: "https://cdn.shopify.com/s/files/1/1705/5713/files/June_-_Alexandrite_-_Round.png?v=1790613399",
    July: "https://cdn.shopify.com/s/files/1/1705/5713/files/July_-_Ruby_-_Round.png?v=1790613400",
    August:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/August_-_Peridot_-_Round.png?v=1790613401",
    September:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/September_-_Sapphire_-_Round.png?v=1790613403",
    October:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/October_-_Tourmaline_-_Round.png?v=1790613404",
    November:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/November_-_Citrine_-_Round.png?v=1790613405",
    December:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/December_-_Blue_Topaz_-_Round.png?v=1790613407",
    /* Metal color swatches (2026-07-27): gradient circles as inline SVG data
       URIs — any Color option containing these words swatchifies too (B1G2
       widget + quick-pick). "Rose Gold" MUST stay before "Gold": forValue
       checks keys in insertion order and "18k Yellow Gold" should fall
       through to the generic Gold entry. */
    /* 2026-10-06: two-tone swatch for the Hailey "Mixed Metal" earrings (gold hoop,
       silver setting) — gold top-right / silver bottom-left on the diagonal. */
    "Mixed Metal":
      "data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2040%2040'%3E%3Cdefs%3E%3ClinearGradient%20id='g'%20x1='0'%20y1='0'%20x2='1'%20y2='1'%3E%3Cstop%20offset='0'%20stop-color='%23F6E4A9'/%3E%3Cstop%20offset='.55'%20stop-color='%23DDB56C'/%3E%3Cstop%20offset='1'%20stop-color='%23B08A42'/%3E%3C/linearGradient%3E%3ClinearGradient%20id='s'%20x1='0'%20y1='0'%20x2='1'%20y2='1'%3E%3Cstop%20offset='0'%20stop-color='%23F5F6F7'/%3E%3Cstop%20offset='.55'%20stop-color='%23CBCFD4'/%3E%3Cstop%20offset='1'%20stop-color='%23A6ABB2'/%3E%3C/linearGradient%3E%3CclipPath%20id='c'%3E%3Ccircle%20cx='20'%20cy='20'%20r='19'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg%20clip-path='url%28%23c%29'%3E%3Cpath%20d='M0%200H40V40Z'%20fill='url%28%23g%29'/%3E%3Cpath%20d='M0%200V40H40Z'%20fill='url%28%23s%29'/%3E%3C/g%3E%3Ccircle%20cx='20'%20cy='20'%20r='19'%20fill='none'%20stroke='%23d9d2c7'%20stroke-width='1'/%3E%3C/svg%3E",
    "Rose Gold":
      "data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2040%2040'%3E%3Cdefs%3E%3ClinearGradient%20id='g'%20x1='0'%20y1='0'%20x2='1'%20y2='1'%3E%3Cstop%20offset='0'%20stop-color='%23F7D7C4'/%3E%3Cstop%20offset='.55'%20stop-color='%23E2A587'/%3E%3Cstop%20offset='1'%20stop-color='%23C08265'/%3E%3C/linearGradient%3E%3C/defs%3E%3Ccircle%20cx='20'%20cy='20'%20r='19'%20fill='url(%23g)'%20stroke='%23d9d2c7'%20stroke-width='1'/%3E%3C/svg%3E",
    Silver:
      "data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2040%2040'%3E%3Cdefs%3E%3ClinearGradient%20id='g'%20x1='0'%20y1='0'%20x2='1'%20y2='1'%3E%3Cstop%20offset='0'%20stop-color='%23F5F6F7'/%3E%3Cstop%20offset='.55'%20stop-color='%23CBCFD4'/%3E%3Cstop%20offset='1'%20stop-color='%23A6ABB2'/%3E%3C/linearGradient%3E%3C/defs%3E%3Ccircle%20cx='20'%20cy='20'%20r='19'%20fill='url(%23g)'%20stroke='%23d9d2c7'%20stroke-width='1'/%3E%3C/svg%3E",
    Gold:
      "data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2040%2040'%3E%3Cdefs%3E%3ClinearGradient%20id='g'%20x1='0'%20y1='0'%20x2='1'%20y2='1'%3E%3Cstop%20offset='0'%20stop-color='%23F6E4A9'/%3E%3Cstop%20offset='.55'%20stop-color='%23DDB56C'/%3E%3Cstop%20offset='1'%20stop-color='%23B08A42'/%3E%3C/linearGradient%3E%3C/defs%3E%3Ccircle%20cx='20'%20cy='20'%20r='19'%20fill='url(%23g)'%20stroke='%23d9d2c7'%20stroke-width='1'/%3E%3C/svg%3E",
  },
  /* TRUE pear-cut stones (Verity "Oval Stone" seat) */
  pear: {
    January:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/January_-_Garnet_-_Oval.png?v=1790613408",
    February:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/February_-_Amethyst_-_Oval.png?v=1790613409",
    March:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/March_-_Aquamarine_-_Oval.png?v=1790613410",
    April:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/April_-_Diamond_-_Oval.png?v=1790613411",
    May:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/May_-_Emerald_-_Oval.png?v=1790613412",
    June:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/June_-_Alexandrite_-_Oval.png?v=1791946407",
    July:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/July_-_Ruby_-_Oval.png?v=1790613415",
    August:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/August_-_Peridot_-_Oval.png?v=1790613416",
    September:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/September_-_Sapphire_-_Oval.png?v=1790613418",
    October:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/October_-_Tourmaline_-_Oval.png?v=1790613419",
    November:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/November_-_Citrine_-_Oval.png?v=1790613420",
    December:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/December_-_Blue_Topaz_-_Oval.png?v=1790613422",
  },
  /* TRUE radiant/rectangle-cut stones (Verity "Rectangle Stone" seat) */
  rect: {
    January:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/January_-_Garnet_-_Rectangle.png?v=1790613423",
    February:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/February_-_Amethyst_-_Rectangle.png?v=1790613424",
    March:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/March_-_Aquamarine_-_Rectangle.png?v=1790613425",
    April:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/April_-_Diamond_-_Rectangle.png?v=1790613426",
    May:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/May_-_Emerald_-_Rectangle.png?v=1790613428",
    June:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/June_-_Alexandrite_-_Rectangle.png?v=1791946407",
    July:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/July_-_Ruby_-_Rectangle.png?v=1790613430",
    August:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/August_-_Peridot_-_Rectangle.png?v=1790613432",
    September:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/September_-_Sapphire_-_Rectangle.png?v=1790613433",
    October:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/October_-_Tourmaline_-_Rectangle.png?v=1790613434",
    November:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/November_-_Citrine_-_Rectangle.png?v=1790613435",
    December:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/December_-_Blue_Topaz_-_Rectangle.png?v=1790613436",
  },
  /* 2026-10-07 SPARKLE set — bright faceted round chips ("<Month> - <Stone> - Sparkle.png"
     in Shopify Files). Opt-in per product via tag `sparkle-swatches` (see forValue). */
  sparkle: {
    January:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/January_-_Garnet_-_Sparkle.png?v=1791424825",
    February:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/February_-_Amethyst_-_Sparkle.png?v=1791424830",
    March:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/March_-_Aquamarine_-_Sparkle.png?v=1791424834",
    April:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/April_-_Diamond_-_Sparkle.png?v=1791424838",
    May:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/May_-_Emerald_-_Sparkle.png?v=1791424843",
    June:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/June_-_Alexandrite_-_Sparkle.png?v=1791424847",
    July:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/July_-_Ruby_-_Sparkle.png?v=1791424851",
    August:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/August_-_Peridot_-_Sparkle.png?v=1791424855",
    September:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/September_-_Sapphire_-_Sparkle.png?v=1791424863",
    October:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/October_-_Tourmaline_-_Sparkle.png?v=1791424868",
    November:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/November_-_Citrine_-_Sparkle.png?v=1791424872",
    December:
      "https://cdn.shopify.com/s/files/1/1705/5713/files/December_-_Blue_Topaz_-_Sparkle.png?v=1791424876",
  },
  _lookup(value, map) {
    for (const name in map) {
      if (value.includes(name.toLowerCase())) return map[name];
    }
    return null;
  },
  /* 2026-10-07: opt-in SPARKLE set (bright faceted chips) for products tagged
     `sparkle-swatches` — first used by the Fleur Spinning Birthstone Necklace.
     PDP: theme.liquid sets window.ALSwatchSet = "sparkle" from the product tag;
     collection quick-pick passes the set name as the 3rd arg from product.tags.
     Products without the tag keep the Round/Oval/Rectangle maps above. */
  forValue(value, optionName, set) {
    if (!value) return null;
    const v = String(value).toLowerCase();
    const named = set || window.ALSwatchSet;
    if (named && this[named] && named !== "map") {
      const hit = this._lookup(v, this[named]);
      if (hit) return hit;
    }
    if (optionName) {
      const o = String(optionName).toLowerCase();
      let shaped = null;
      if (/oval|pear|teardrop/.test(o)) shaped = this.pear;
      else if (/rect|radiant|square/.test(o)) shaped = this.rect;
      if (shaped) {
        const hit = this._lookup(v, shaped);
        if (hit) return hit;
      }
    }
    return this._lookup(v, this.map);
  },
};
